import {AppSettings} from '../constants';
import Jwt from '../helper/interceptors';
import { ObjToParam, MapResponse } from '../helper/helper-api';

export const create = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).post('/api/workorders', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const upload = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI, true, 'multipart/form-data')
    .post('/api/workorders/uploadfiles', params, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};
export const createWorkOrderType = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).post('/api/workorder-types', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const update = (params) => {

  return Jwt(AppSettings.CURRENT_SITE_URI).put('/api/workorder-types', params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getById = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/workorder-types/${params}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const search = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/workorder-types/search?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};




// WEBPACK FOOTER //
// ./src/Work-Order-Type/api.js